import React from "react";

import { useLanguage, LanguageType } from "@narvar/nth-kit-returns-headless";
import StyledMarkup from "../StyledMarkup";

const Language = ({
  langKey,
  replacementTokens = [],
  defaultString,
  noWrap,
  style,
  tagName,
  attributes,
}: LanguageType) => {
  const { value } = useLanguage({
    langKey,
    replacementTokens,
    defaultString,
  });

  return (
    <StyledMarkup
      content={value}
      tagName={tagName}
      attributes={attributes}
      noWrap={noWrap}
      style={style}
    />
  );
};

export default Language;
